"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brazeUKSubscriptionGroup = exports.brazeUSSubscriptionGroup = exports.proxyApiUrl = exports.apiKey = void 0;
const config_1 = require("../config");
exports.apiKey = config_1.brazeApiKey;
exports.proxyApiUrl = config_1.brazeProxyUrl;
exports.brazeUSSubscriptionGroup = config_1.brazeUSSubscriptionGroupId;
exports.brazeUKSubscriptionGroup = config_1.brazeUKSubscriptionGroupId;
//# sourceMappingURL=braze.js.map